import styled from 'styled-components';

export const DateInputWrapper = styled.div`
  position: relative;
  flex: 1;
`;

export const DateInput = styled.input`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.sm} 12px;
  padding-right: 40px;
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  border-radius: ${({ theme }) => theme.radii.md};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.textDark};
  background-color: ${({ theme }) => theme.colors.white};
  text-align: left;
  box-sizing: border-box;
  cursor: pointer;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textPlaceholder};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const DateInputIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  pointer-events: none;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.textPlaceholder};
`;

export const TwoDateInputs = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.xs};
`;